// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-tabview .p-tabview-panels .price-tab-panel {
  padding: 0 !important;
}

::ng-deep .p-tabview .p-tabview-panels {
  padding: 0 !important;
}

.invoice-dialog {
  font-family: Arial, sans-serif;
  color: #333;
}

.page {
  width: 200mm;
  min-height: 286mm;
  padding: 0;
  margin: 0;
  background: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.invoice-header, .invoice-footer {
  text-align: center;
  margin-bottom: 20px;
}

.invoice-header h2, .invoice-header h3 {
  margin: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  page-break-inside: auto;
}

th, td {
  border: 1px solid #ccc;
  padding: 4px;
  font-size: 12px;
}

th {
  background-color: #f2f2f2;
}

@media print {
  body, .page {
    margin: 0;
    box-shadow: none;
  }
  .page {
    page-break-after: always;
  }
  table, th, td {
    font-size: 11px;
  }
  .print-mb-bt {
    padding-bottom: 1mm !important;
    display: block !important;
    margin: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/myaccount/myaccount.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,8BAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,yBAAA;EAEA,uBAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI;IACI,SAAA;IACA,gBAAA;EAAN;EAGE;IACI,wBAAA;EADN;EAIE;IACI,eAAA;EAFN;EAIE;IACI,8BAAA;IACA,yBAAA;IACA,oBAAA;EAFN;AACF","sourcesContent":["::ng-deep .p-tabview .p-tabview-panels .price-tab-panel {\n    padding: 0 !important;\n}\n\n::ng-deep .p-tabview .p-tabview-panels {\n    padding: 0 !important;\n}\n\n.invoice-dialog {\n    font-family: Arial, sans-serif;\n    color: #333;\n}\n\n.page {\n    width: 200mm;\n    min-height: 286mm;\n    padding: 0;\n    margin: 0;\n    background: white;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n}\n\n.invoice-header, .invoice-footer {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.invoice-header h2, .invoice-header h3 {\n    margin: 0;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    //margin-bottom: 15px;\n    page-break-inside: auto;\n}\n\nth, td {\n    border: 1px solid #ccc;\n    padding: 4px;\n    font-size: 12px;\n}\n\nth {\n    background-color: #f2f2f2;\n}\n\n@media print {\n    body, .page {\n        margin: 0;\n        box-shadow: none;\n    }\n\n    .page {\n        page-break-after: always;\n    }\n\n    table, th, td {\n        font-size: 11px;\n    }\n    .print-mb-bt {\n        padding-bottom: 1mm !important;\n        display: block !important;\n        margin: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
